import { render, staticRenderFns } from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=template&id=5823df39&scoped=true&"
import script from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkspaceGroupWorkspaces.vue?vue&type=style&index=0&id=5823df39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823df39",
  null
  
)

export default component.exports